<div class="flex-direction-row gap-5 align-center">
  @if (carregandoInfo) {
    <div class="skeleton" style="width: 90px; height: 20px;"></div>
  } @else {
    <span
      class="label"
      [style.font-size]="fontSize"
      [style.order]="invertido ? 3 : 1"
      [ngClass]="valor ? 'selecionado' : 'desselecionado'"
    >{{ labelTrue }}</span>

    <mat-slide-toggle
      class="toggle-padrao"
      [ngClass]="{ 'invertido': invertido }"
      [style.order]="2"
      [(ngModel)]="valor"
      (ngModelChange)="change()"
      [disabled]="disabled"
    ></mat-slide-toggle>

    <span
      class="label"
      [style.font-size]="fontSize"
      [style.order]="invertido ? 1 : 3"
      [ngClass]="!valor ? 'selecionado' : 'desselecionado'"
    >{{ labelFalse }}</span>
  }
</div>
